import { render, staticRenderFns } from "./weisu.vue?vue&type=template&id=c62b4386&scoped=true"
import script from "./weisu.vue?vue&type=script&lang=js"
export * from "./weisu.vue?vue&type=script&lang=js"
import style0 from "./weisu.vue?vue&type=style&index=0&id=c62b4386&prod&scoped=true&lang=css"
import style1 from "./weisu.vue?vue&type=style&index=1&id=c62b4386&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62b4386",
  null
  
)

export default component.exports